// extracted by mini-css-extract-plugin
export default {"root":"style_root__6Fg9U","win":"style_win__HPu3y","loss":"style_loss__Og2EY","tie":"style_tie__xHJLf","inner":"style_inner__4Y8dl"};